import * as React from 'react'
export default function CampaignImageIcon(): React.ReactElement<'svg'> {
  return (
    <svg width="85" height="58">
      <path
        d="M35.215 14.984c2.745 0 4.978 2.222 4.978 4.954 0 2.731-2.233 4.953-4.978 4.953-2.746 0-4.979-2.222-4.979-4.953 0-2.732 2.233-4.954 4.979-4.954zm0-2.9c-4.353 0-7.893 3.524-7.893 7.854 0 4.331 3.541 7.855 7.893 7.855s7.893-3.524 7.893-7.855c0-4.33-3.541-7.854-7.893-7.854zM18.362 30.081L43.588 55.1H2.916v-9.697l15.446-15.322zm63.723-27.18l.001 39.267L59.68 19.761h-2.066L38.068 39.308l.005 2.05 2.06-.005L58.646 22.84l22.65 22.649c.221.222.502.332.79.38V55.1h-34.37L19.391 27.006h-2.056L2.915 41.309V2.901h79.17zM1.458 0C.652 0 0 .65 0 1.451V56.55C0 57.351.652 58 1.458 58h82.085c.805 0 1.457-.649 1.457-1.45V1.451C85 .651 84.348 0 83.543 0H1.458z"
        fill="#5f63ee"
      />
    </svg>
  )
}
